import { setAvailableOrganizations } from './AvailableOrganizations';
import { setCurrentUser, disposeCurrentUser } from './CurrentUser';
import { setErrors, disposeErrors } from './Errors';
import { setLastAccessedOrganization, disposeLastAccessedOrganization } from './LastAccessedOrganization';
import { default as SIGNOUT } from './deleteToken';

import { availableOrganizationsVar, currentUserVar, errorsVar, lastAccessedOrganizationVar } from '../../cache';

const commands = {
  // AvailableOrganization
  setAvailableOrganizations: setAvailableOrganizations(availableOrganizationsVar),
  /* no need for now because every user has to belong to, at least, an organization
  disposeAvailableOrganizations: disposeAvailableOrganizations(availableOrganizationsVar),
  */
  // CurrentUser
  setCurrentUser: setCurrentUser(currentUserVar),
  disposeCurrentUser: disposeCurrentUser(currentUserVar),
  // Errros
  setErrors: setErrors(errorsVar),
  disposeErrors: disposeErrors(errorsVar),
  // LastAccessedOrganization
  setLastAccessedOrganization: setLastAccessedOrganization(lastAccessedOrganizationVar),
  disposeLastAccessedOrganization: disposeLastAccessedOrganization(lastAccessedOrganizationVar),
  // Documennts for REST APIs
  SIGNOUT: SIGNOUT,
};

export default commands;
